import React, { type FC } from "react";
import { BusinessList } from "@src/components/business-list";
import { BusinessMeasureValue, BusinessStockObjValue } from "@src/components/business-data-display";
import { ListItem } from "@src/components/business-list";
import type { WsInvActContent } from "../../../../../../api/wsInvActs";
import "./WsInvActIndefiniteResultContent.scss";

/** Пропсы выбора при неоднозначном поиске состава АИ. */
export interface WsInvActIndefiniteResultContentProps {
    stockObjSign: string;
    choices: WsInvActContent[];
    /** Обработчик выбора элемента (закрытие overlay — у opener через `OverlayHandle`). */
    onSelect: (contentCode: number) => void | Promise<void>;
}

/**
 * Список вариантов при неоднозначном поиске элемента состава АИ (content для mobile window).
 */
export const WsInvActIndefiniteResultContent: FC<WsInvActIndefiniteResultContentProps> = ({
    stockObjSign,
    choices,
    onSelect,
}) => (
    <div className="ws_inv_act_indefinite_window">
        <p className="ws_inv_act_indefinite_window__hint">
            Неоднозначный поиск по &quot;Обозначение ТМЦ&quot; со значением &quot;{stockObjSign}&quot;. Выберите элемент
            состава АИ.
        </p>

        <BusinessList>
            {choices.map((content) => (
                <ListItem
                    key={content.Code}
                    title={<BusinessStockObjValue stockObj={content.WsDepotCard?.Stockobj} />}
                    props={[
                        {
                            label: "Количество факт",
                            value: <BusinessMeasureValue value={content.FactQty} measure={content.WsDepotCard?.Measure} />,
                        },
                    ]}
                    onClick={() => {
                        void onSelect(content.Code);
                    }}
                />
            ))}
        </BusinessList>
    </div>
);
